export const ordenacaoEnum = {
    NENHUMA: 0,
    CRESCENTE: 1,
    DECRESCENTE: 2
};